export { default } from './SocialMediaBlock';
export * from './SocialMediaBlock';
